























































































import {Vue, Component} from "vue-property-decorator";

@Component({
    name: "UserManagementPage"
})
export default class UserManagementPage extends Vue {
    private users: any[] = [];
    private addedUser: any = null;
    private updatedUser: any = null;

    private fields = [
        "email",
        "roles",
        "zones",
    ];

    mounted() {
        this.getUserList();
    }

    getUserList() {
        return this.axios.get("Users/List")
            .then(usersResponse => {
                console.log("usersResponse: ", usersResponse);
                this.users = usersResponse.data;
            });
    }

    updateUser(item: any) {
        console.log("item: ", item);
        this.updatedUser = item[0];
    }

    submitUpdate() {
        this.axios.post("Users/Update", this.updatedUser)
            .then(resp => {
                console.log("updateResp: ", resp);
                this.getUserList().finally(() => {
                    this.updatedUser = null
                });
            })
    }

    submitAdd() {
        this.axios.post("Users/Create", this.addedUser)
            .then(resp => {
                console.log("resp: ", resp);
                this.getUserList().finally(() => {
                    this.addedUser = null
                });
            })
            .catch(err => {
                console.warn("err: ", err);
            })
    }

    addUser() {
        this.addedUser = {
            name: "",
            email: "",
            roles: "",
            zones: "",
        };
    }
}
